module.exports = __webpack_public_path__ + "img/10252025_753163378059452_2673095765852401086_n.aaed03ce.jpg";